"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE = void 0;
var MODULE;
(function (MODULE) {
    /**
     * App Features
     */
    MODULE["APP_FEATURES"] = "app-features";
    /**
     * Email Templates
     */
    MODULE["EMAIL_TEMPLATES"] = "email-templates";
    /**
     * CORS Whitelist Settings
     */
    MODULE["CORS_WHITELISTED_URL"] = "cors-whitelisted-url";
    /**
     * Messaging Service Settings
     */
    MODULE["MESSAGING_SERVICE_SETTINGS"] = "messaging-service-settings";
})(MODULE = exports.MODULE || (exports.MODULE = {}));
//# sourceMappingURL=cms.interface.js.map